import request from '@/router/axios';

//020201-05 查询租户下的代码项集合
export function getCodeListBySetId(codeSetId) {
  return request({
    url: '/code/getCodeListBySetId/'+codeSetId,
    method: 'get',
  });
}


